// src/components/base/LoadingSpinner/LoadingSpinner.tsx
import type { ComponentChildren } from 'preact';
// styles
import styles from './LoadingSpinner.module.css';

interface LoadingSpinnerProps {
  title?: string;
  message?: string;
  className?: string;
  children?: ComponentChildren;
}

/**
 * A reusable loading spinner with optional title and message.
 * Spinner uses the brand primary colour from theme.
 */
export function LoadingSpinner({
  title = '',
  message = '',
  children,
}: LoadingSpinnerProps) {
  return (
    <div className={styles.spinnerWrapper}>
      <div className={styles.spinner} aria-label="Loading" />
      <div className={styles.title}>{title}</div>
      <div className={styles.message}>{message}</div>
      {children}
    </div>
  );
}
